import { message } from 'ant-design-vue';
import '@/assets/styles/styleCompatibility.css';

export const isPresetIncompatible = (preset) => (preset?.compatibility ?? [])
  .some((check) => check.status === 'incompatible')
  || preset?.requested_compatibility?.status === 'incompatible';

const describeCheck = (check) => {
  const prefix = check.crm_plan_id ? `ID планировки: ${check.crm_plan_id}. ` : '';
  const revision = check.newer_revision ? `Появилась новая ревизия №${check.revision_id}. ` : '';
  if (check.status === 'unknown') {
    return `${prefix}${revision}Для стиля «${check.style_name}» нет данных о поддерживаемых типах комнат. `
      + 'Результат может выглядеть не так, как вы ожидаете.';
  }
  if (check.status === 'incompatible') {
    return `${prefix}${revision}Стиль «${check.style_name}». Неподдерживаемые типы комнат: `
      + `${check.unsupported_room_types.join(', ')}. Эти комнаты могут выглядеть не так, как вы ожидаете.`;
  }
  return check.newer_revision ? `${prefix}${revision}Неподдерживаемых типов комнат нет.` : '';
};

export const compatibilityMessage = (checks = []) => {
  const lines = checks.map(describeCheck).filter(Boolean);
  if (!lines.length) return '';
  if (checks.length > 1) {
    const count = checks.filter((check) => check.status === 'incompatible').length;
    const unknownCount = checks.filter((check) => check.status === 'unknown').length;
    lines.push(`Итого: неподдерживаемые типы комнат у ${count} из ${checks.length} планировок.`);
    if (unknownCount) lines.push(`Совместимость не проверена для ${unknownCount} планировок.`);
  }
  return lines.join('\n');
};

export const showCompatibility = (checks) => {
  const content = compatibilityMessage(checks);
  if (content) {
    message.warning({
      key: content, content, duration: 10, class: 'style-compatibility-message',
    });
  }
};

export const warnPresetSelection = (preset) => showCompatibility(preset?.compatibility?.length
  ? preset.compatibility : [preset?.requested_compatibility].filter(Boolean));
